import React from 'react';
const noMore = ['No more hours rebuilding flight lessons.', 'No more searching through random training resources.', 'No more explaining complex concepts without visual support.', 'No more disconnected lesson ideas.', 'No more wondering what the student should work on next.', 'No more recreating the same briefings again and again.', 'No more starting every lesson from an empty page.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-blue-950 relative overflow-hidden" data-id="element-105" data-mp="m341kkh9jmdm">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-106" data-mp="h52g5swd7ayz">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white uppercase" data-id="element-107" data-mp="vv9qflc7xnol">
          Next Week You Can Keep Planning Every Flight Lesson From Scratch...
          <br data-id="element-108" data-mp="14vg1z1ocwdl4" />
          <span className="text-orange-500" data-id="element-109" data-mp="14uwtebklj1jr">
            Or You Can Open a Complete 6-in-1 Visual Teaching System and Already Know Where to
            Start.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-110" data-mp="2c4wo4ojgcche">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-111" data-mp="2h3zuqdf2yqrh">
              <span className="text-orange-500 mt-0.5" aria-hidden="true" data-id="element-112" data-mp="2m2krg2v4isb6">
                ▸
              </span>
              <span className="text-white/85" data-id="element-113" data-mp="2r2ozd4hyueps">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-114" data-mp="2v2r5bpuqhuav">
          Flight Instructor Ready Does Not Replace Your Experience.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-115" data-mp="34tby2wnq84lv">
          It gives you a system for using that experience with greater:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-orange-500" data-id="element-116" data-mp="39rdh5hl5k3xc">
          STRUCTURE · CLARITY · CONSISTENCY · EFFICIENCY
        </p>
      </div>
    </section>;
}